<div class="noModuleAvailable">
  <div class="noModuleAvailable__bulletsCont">
    <app-ds-typography [color]="fontColor.Secondary" [fontFamily]="fontFamily.SemiBold" [size]="fontSize.XS" [text]="'NO_MODULE_AVAILABLE.TITLE' | transloco"></app-ds-typography>
    <div class="noModuleAvailable__bullet">
      <span>
        <app-ds-typography [color]="fontColor.Secondary" [fontFamily]="fontFamily.Regular" [size]="fontSize.XXS" [text]="'1'"></app-ds-typography>
      </span>
      <app-ds-typography [tag]="'p'" [color]="fontColor.Secondary" [fontFamily]="fontFamily.Regular" [size]="fontSize.XXS" [text]="'NO_MODULE_AVAILABLE.FIRST_BULLET' | transloco"></app-ds-typography>
    </div>
    <div class="noModuleAvailable__bullet">
      <span>
        <app-ds-typography [color]="fontColor.Secondary" [fontFamily]="fontFamily.Regular" [size]="fontSize.XXS" [text]="'2'"></app-ds-typography>
      </span>
      <app-ds-typography [tag]="'p'" [color]="fontColor.Secondary" [fontFamily]="fontFamily.SemiBold" [size]="fontSize.XXS" [text]="textByProduct | transloco"></app-ds-typography>
    </div>
    <div class="noModuleAvailable__bullet">
      <span>
        <app-ds-typography [color]="fontColor.Secondary" [fontFamily]="fontFamily.Regular" [size]="fontSize.XXS" [text]="'3'"></app-ds-typography>
      </span>
      <app-ds-typography [tag]="'p'" [color]="fontColor.Secondary" [fontFamily]="fontFamily.Regular" [size]="fontSize.XXS" [text]="'NO_MODULE_AVAILABLE.LAST_BULLET' | transloco"></app-ds-typography>
    </div>
  </div>
  <div class="noModuleAvailable__QR">
    <app-ds-image
      [size]="null"
      [src]="image | ImageCdn"
      [alt]="'Rappi App QR Code'">
    </app-ds-image>
  </div>
</div>
